// extracted by mini-css-extract-plugin
export var actionIcon = "_uf-0";